import React from 'react';

import FormItemConst from '../../formItem/FormItemConst';
import Warning from '../../utils/Warn';
import {LookupAutoQueryStore} from '../../stores/LookupStores';
import FormItemLongDisplay from '../../formItem/display/FormItemLongDisplay';
import FormItemLongResolver from '../../formItem/resolver/FormItemLongResolver';

export default class AutoLookupLongEditor extends React.Component
{
	constructor(props) 
	{
		super(props);
		this.state = {inQueryGroup:false};
		this.classAlias = "AutoLookupLongEditor";
		this.unsubscribeLookupAutoQueryStore = LookupAutoQueryStore.listen(this.onLookupAutoQuery.bind(this));
	}

	onLookupAutoQuery(key,args)
	{
		if(this.props.lookupKey == key && this.state.inQueryGroup)
		{
			args[this.props.tableField.name] = this.record;
		}
	}

	setFinalValue(value)
	{
		if(!value)
			value = $(this.inputField).val();
		value = FormItemLongResolver.getResult(value,false,this.props.allowNegative);
		if(value.indexOf("false:") == 0)
		{
			Warning.show({text:value.substr(6)});
			return;
		}
		this.record = value;
	}

	inputFieldBlur()
	{
		this.setFinalValue();
		//todo 值回送数据完成以后 严格按照显示要求再进行显示
		this.setDisplay();	
		
	}


	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			value = this.record;
		}

		value = FormItemLongDisplay.getDisplayText(value,this.props.showZero,this.props.thousandSeperator);

		$(this.inputField).val(value);
	}

	onKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			
		}
		else if(e.keyCode>64&&e.keyCode<91)
		{
			e.preventDefault();
		}
	}


	labelClickHandler()
	{
		this.setState({inQueryGroup:!this.state.inQueryGroup});
	}

	getInputDom()
	{
		let _id = this.props.id;
		let displayLength=this.props.displayLength;
		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		if(this.state.inQueryGroup)
		{
			return <input ref={node => this.inputField = node} onBlur={this.inputFieldBlur.bind(this)} id={_id} style={{width:_width,marginLeft:'5px',padding:'2px',height:FormItemConst.EDITOR_HEIGHT}} spellCheck="false" className="form-control" onKeyDown={this.onKeyDownHandler.bind(this)}></input>
		}
		else
		{
			return <input ref={node => this.inputField = node} onBlur={this.inputFieldBlur.bind(this)} readOnly="readonly" spellCheck="false" className="form-control" id={_id} style={{width:_width,marginLeft:'5px',height:FormItemConst.EDITOR_HEIGHT,backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,padding:'2px'}} onKeyDown={this.onKeyDownHandler.bind(this)}></input>
		}
	}

	render()
	{
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center'};
		let _id = this.props.id;
		let labelStyle={paddingLeft:'5px',cursor:'pointer',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		if(!this.state.inQueryGroup)
		{
			labelStyle.color = "#CFCFCF";
		}
		let inputDom = this.getInputDom();
		return(
			<div ref={node => this.element = node} className='editorGroup' style={editorStyle}>
				<label htmlFor={_id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
					style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
					{this.props.label}
				</label>
				{inputDom}
			</div>
		);
		
	}

}


// WEBPACK FOOTER //
// ./src/components/autoLookup/AutoLookupLongEditor.js